<template>
  <tr class="customer-ortho-ipr" :class="{ selected: is_selected }" @click="$emit('select', ipr)">
    <td class="customer-ortho-ipr__date">
      {{ created_at }}
    </td>
    <td class="customer-ortho-ipr__upper">
      {{ ipr.upper_arch }}
    </td>
    <td class="customer-ortho-ipr__lower">
      {{ ipr.lower_arch }}
    </td>
    <td class="customer-ortho-ipr__notes">
      {{ ipr.notes }}
    </td>
    <td class="customer-ortho-ipr__actions">
      <button type="button" class="btn btn-wabident-round small" @click="$emit('edit', ipr)">
        Editar
      </button>
      <button type="button" class="btn btn-wabident-round small red" @click="$emit('delete', ipr)">
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['ipr', 'customer', 'selected_tooth', 'selected_ipr'],
  data() {
    return {
    }
  },
  computed: {
    is_selected() {
      if (this.selected_ipr == this.ipr.id) {
        return true;
      }

      if (this.selected_tooth > 0) {
        const tooth_str = String(this.selected_tooth);
        return (this.ipr.upper_arch && this.ipr.upper_arch.includes(tooth_str)) ||
          (this.ipr.lower_arch && this.ipr.lower_arch.includes(tooth_str));
      }

      return false;
    },
    created_at() {
      if (this.ipr.created_at) {
        return window.WabiDent.fmtDate(this.ipr.created_at);
      }
      return '';
    },
  },
}
</script>

<style lang="scss">
.customer-ortho-ipr__actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
</style>
